var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/header';
import "./index.scss";
var MyModel = /** @class */ (function (_super) {
    __extends(MyModel, _super);
    function MyModel(root) {
        return _super.call(this, "/api/Users", root, { Nickname: ko.observable(), Password: ko.observable(), Password2: ko.observable() }) || this;
    }
    MyModel.prototype.rigister = function () {
        this.saveData().then(function (d) { d && window.popBox.show("操作成功。"); });
    };
    MyModel.prototype.onValidating = function (d) {
        if (!d.Nickname()) {
            return "请输入用户名。";
        }
        if (!d.Password()) {
            return "请输入密码。";
        }
        return null;
    };
    return MyModel;
}(KnockoutModel));
var MyViewModel = /** @class */ (function (_super) {
    __extends(MyViewModel, _super);
    function MyViewModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasLayout = false;
        return _this;
    }
    MyViewModel.prototype.init = function () {
        this.c = new MyModel(this.container);
        this.c.bind();
    };
    MyViewModel.prototype.update = function (arg) {
        return Promise.resolve();
    };
    return MyViewModel;
}(Page));
export default MyViewModel;
